'use client';
import React, { ReactNode, useMemo } from 'react';
import { VerticalType } from '../../types/cmsTypes';
import { CmsClientProvider } from './CmsClientProvider';
import { useCmsClientContext } from './useCmsClientContext';

type CmsClientVerticalScopeProps = {
  /** Vertical for the subtree; `undefined` keeps the outer (page) vertical. */
  vertical: VerticalType | undefined;
  children: ReactNode;
};

/**
 * Re-provides `CmsClientContext` with `vertical` replaced and everything else
 * kept. Consumers (`useCtaUrl` / `<ApplyCtaLink>`, ProductCard sections) read the
 * vertical from context, so a block listing products of another vertical than
 * the page's has to override the `PageDataProvider` value here (CMS-1987).
 */
export const CmsClientVerticalScope: React.FC<CmsClientVerticalScopeProps> = ({
  vertical,
  children,
}) => {
  const outer = useCmsClientContext();
  const value = useMemo(
    () => ({ ...outer, vertical: vertical ?? outer.vertical }),
    [outer, vertical],
  );

  return <CmsClientProvider value={value}>{children}</CmsClientProvider>;
};
